'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

exports.createChooseProviderSaga = createChooseProviderSaga;

var _effects = require('redux-saga/effects');

var _actionsTypeConsts = require('./actionsTypeConsts.js');

var _actionsTypeConsts2 = _interopRequireDefault(_actionsTypeConsts);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createChooseProviderSaga(storeApi, providerApi) {
  // eslint-disable-next-line func-names
  return (/*#__PURE__*/_regenerator2.default.mark(function chooseProvider(_ref) {
      var provider = _ref.payload;
      var appDefId;
      return _regenerator2.default.wrap(function chooseProvider$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              appDefId = provider.appDefId;
              _context.prev = 1;
              _context.next = 4;
              return storeApi.connectProvider(appDefId);

            case 4:
              _context.next = 6;
              return providerApi.setProviderSetOnSite();

            case 6:
              _context.next = 8;
              return (0, _effects.put)({
                type: _actionsTypeConsts2.default.providerSuccessfullyChanged,
                payload: provider
              });

            case 8:
              _context.next = 13;
              break;

            case 10:
              _context.prev = 10;
              _context.t0 = _context['catch'](1);

              console.error('Error connecting provider', _context.t0);

            case 13:
            case 'end':
              return _context.stop();
          }
        }
      }, chooseProvider, this, [[1, 10]]);
    })
  );
}